// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentConditionTypeModel {
    static getAttributeTypeMap() {
        return EnrollmentConditionTypeModel.attributeTypeMap;
    }
}
EnrollmentConditionTypeModel.discriminator = undefined;
EnrollmentConditionTypeModel.additionalProperties = false;
EnrollmentConditionTypeModel.attributeTypeMap = [
    {
        "name": "caseId",
        "baseName": "caseId",
        "type": "number"
    },
    {
        "name": "code",
        "baseName": "code",
        "type": "string"
    },
    {
        "name": "description",
        "baseName": "description",
        "type": "string"
    },
    {
        "name": "categoryCode",
        "baseName": "categoryCode",
        "type": "string"
    },
];
//# sourceMappingURL=enrollmentConditionTypeModel.js.map